module.exports = __webpack_public_path__ + "img/social-club-icon.d38531e7.png";